namespace Matrix.Rebalancer {
    export namespace ModellingViewColumnSetService {
        export const baseUrl = 'Rebalancer/ModellingViewColumnSet';

        export declare function Create(request: Serenity.SaveRequest<ModellingViewColumnSetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ModellingViewColumnSetRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ModellingViewColumnSetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ModellingViewColumnSetRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Rebalancer/ModellingViewColumnSet/Create",
            Update = "Rebalancer/ModellingViewColumnSet/Update",
            Delete = "Rebalancer/ModellingViewColumnSet/Delete",
            Retrieve = "Rebalancer/ModellingViewColumnSet/Retrieve",
            List = "Rebalancer/ModellingViewColumnSet/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ModellingViewColumnSetService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
